<template>
  <div v-title data-title="券码详情" style="font-size:1.3rem">
    <div class="page">
      <vue-qr
        style="text-align:center;margin-top:20px"
        :logoSrc="config.imagePath"
        :text="config.value"
        :size="200"
        :margin="0"
      ></vue-qr>
      <wv-footer class="footer-demo" :text="formset.TollCode"></wv-footer>

      <div class="weui-spaces" style="margin-top:15px"></div>
      <wv-group>
        <wv-cell title="券码类型" :value="formset.CodeTypeName"></wv-cell>
        <wv-cell title="状态" :value="formset.ChargeOffStateName"></wv-cell>
        <wv-cell v-if="formset.ConfirmTime" title="核销时间" :value="formset.ConfirmTime"></wv-cell>
        <wv-cell v-if="formset.ConfrimUserID>0" title="核销人" :value="formset.ConfrimUserName"></wv-cell>
      </wv-group>
    </div>
  </div>
</template>

<script>
import { Toast } from "we-vue";
import Vue from "vue";
import VueQr from "vue-qr";

export default {
  components: { VueQr },
  name: "rollcodedetail",
  data: function() {
    return {
      LoginType: -1,
      formset: {},
      source: {},
      config: {
        value: "", //显示的值、跳转的地址
        imagePath: require("../../assets/logo.png") //中间logo的地址
      }
    };
  },
  created: function() {
    this.Initrollcode();
  },
  methods: {
    initsource: function(sourceid) {
      if (Vue.filter("isUndefined")(sourceid) || sourceid == 0) {
      } else {
        this.getsource(sourceid)
          .get()
          .then(function(d) {
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
              this.source[sourceid] = rep.Data;
            }
          });
      }
    },
    Initrollcode: function() {
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/tbrollcode/get", {
          params: {
            guid: this.$route.query.guid
          }
        })
        .then(function(d) {
          var rep = JSON.parse(d.bodyText);
          if (rep.Success) {
            this.formset = rep.Data;
            this.config.value = this.formset.TollCode;
          } else {
            Toast.fail(rep.Message);
          }
        });
    }
  }
};
</script>

<style>
.weui-spaces {
  height: 10px;
  background-color: #efeff4;
}
</style>




// WEBPACK FOOTER //
// src/components/order/rollcodedetail.vue